var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layer_pop_wrap custom"
  }, [_c('div', {
    staticClass: "layer_pop_dim",
    style: _vm.$props.openFlag ? 'display: flex; position: relative;' : 'display: none'
  }, [_c('div', {
    staticClass: "layer_pop md",
    class: _vm.$props.openFlag ? 'active' : '',
    attrs: {
      "data-role-popup": "modal_01",
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "pop_head"
  }, [_c('h2', [_vm._v("공개하기")]), _c('button', {
    staticClass: "pop_close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clickCloseHandler
    }
  }, [_vm._v("닫기")])]), _c('div', {
    key: _vm.reloadKey,
    staticClass: "pop_cont"
  }, [_c('div', {
    staticClass: "view_cont"
  }, [_c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_c('ul', {
    staticClass: "inp_column col_2"
  }, [_vm._m(0), _c('li', [_c('div', {
    class: _vm.cautionBlnPublic ? 'validation_error' : ''
  }, [_c('label', {
    staticClass: "component_radio",
    attrs: {
      "for": "radio0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicActive,
      expression: "publicActive"
    }],
    attrs: {
      "type": "radio",
      "id": "radio0",
      "name": "rdo00",
      "disabled": _vm.isUnit == true,
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.publicActive, "0")
    },
    on: {
      "change": function ($event) {
        _vm.publicActive = "0";
      }
    }
  }), _c('span', [_vm._v("비공개")])]), _c('label', {
    staticClass: "component_radio",
    attrs: {
      "for": "radio1"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.publicActive,
      expression: "publicActive"
    }],
    attrs: {
      "type": "radio",
      "id": "radio1",
      "name": "rdo00",
      "disabled": _vm.isUnit == true,
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.publicActive, "1")
    },
    on: {
      "change": function ($event) {
        _vm.publicActive = "1";
      }
    }
  }), _c('span', [_vm._v("전체공개")])])])])]), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.cautionBlnPublic,
      expression: "cautionBlnPublic"
    }],
    staticClass: "validation_text",
    domProps: {
      "textContent": _vm._s('공개 범위를 선택해주세요.')
    }
  })])]), _c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_vm._m(1), _c('div', {
    staticClass: "column_input",
    class: _vm.cautionBln ? 'validation_error' : ''
  }, [_c('textarea', {
    ref: "inputWrite",
    class: _vm.cautionBln ? 'validation_error' : '',
    attrs: {
      "rows": "15"
    },
    domProps: {
      "value": _vm.releaseMemo
    },
    on: {
      "keyup": function ($event) {
        return _vm.checkKeyUp($event);
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.cautionBln,
      expression: "cautionBln"
    }],
    staticClass: "validation_text",
    domProps: {
      "textContent": _vm._s('필수 입력값입니다.')
    }
  })])])]), _vm._m(2)])]), _c('div', {
    staticClass: "pop_foot"
  }, [_c('button', {
    staticClass: "sm_btn color_1",
    on: {
      "click": function ($event) {
        return _vm.confirmHandler($event);
      }
    }
  }, [_vm._v(" 완료 ")])])])]), _c('div', {
    ref: "publishCanvas",
    staticClass: "canvas"
  }), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('li', [_c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("범위"), _c('em', [_vm._v("*")])])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("문서 저장 시 필요한 정보를 입력하세요."), _c('em', [_vm._v("*")])])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', {
    staticClass: "column col_1"
  }, [_c('li', [_c('div', {
    staticClass: "label_txt"
  }, [_c('span', [_vm._v("선택한 공개 범위로 공개하시겠습니까?")])])])]);

}]

export { render, staticRenderFns }